import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CustomerPaymentMemoListItem extends SearchModelBase {
    customerName: string = '';
    currency: string = '';
    contact: string = '';
    phone: string = '';
    followUp: string | null = null;
    fromFollowUp: string | null = null;
    toFollowUp: string | null = null;
    lastPaidAmt: number|null = null;
    fromLastPaidAmt: number|null = null;
    toLastPaidAmt: number|null = null;
    terms: number|null = null;
    toTerms: number|null = null;
    fromTerms: number|null = null;
    avgAging: number|null = null;
    toAvgAging: number|null = null;
    fromAvgAging: number|null = null;
    curCnt: number|null = null;
    toCurCnt: number|null = null;
    fromCurCnt: number|null = null;
    pastDueCnt: number|null = null;
    toPastDueCnt: number|null = null;
    fromPastDueCnt: number|null = null;
    checkNo: string = '';
    lastPaidDate: string | null = null;
    fromLastPaidDate: string | null = null;
    toLastPaidDate: string | null = null;
    salesRep: string = '';
    groupId: string = '';
    currentBal: number|null = null;
    fromCurrentBal: number|null = null;
    toCurrentBal: number|null = null;
    pastDue: number|null = null;
    fromPastDue: number|null = null;
    toPastDue: number|null = null;
    days15: number|null = null;
    fromDays15: number|null = null;
    toDays15: number|null = null;
    days30: number|null = null;
    fromDays30: number|null = null;
    toDays30: number|null = null;
    days45: number|null = null;
    fromDays45: number|null = null;
    toDays45: number|null = null;
    days60: number|null = null;
    fromDays60: number|null = null;
    toDays60: number|null = null;
    days90: number|null = null;
    fromDays90: number|null = null;
    toDays90: number|null = null;
    over90: number|null = null;
    fromOver90: number|null = null;
    toOver90: number|null = null;
    balance: number|null = null;
    fromBalance: number|null = null;
    toBalance: number|null = null;
    memo: string = '';
    id: number = 0;
    idAndCurrency: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Customer', width: 200, dataIndex: 'customerName', defaultColumnFocus : true}),
        XCol.Create({ col: 1, text: 'Contact', width: 150, dataIndex: 'contact'}),
        XCol.Create({ col: 2, text: 'Phone', width: 150, dataIndex: 'phone'}),
        XCol.Create({ col: 3, text: 'Followup Date', width: 75, dataIndex: 'followUp', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'CUR', width: 40, dataIndex: 'currency'}),
        XCol.Create({ col: 5, text: 'Last Paid Amount', width: 100, dataIndex: 'lastPaidAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Check #', width: 100, dataIndex: 'checkNo'}),
        XCol.Create({ col: 7, text: 'Paid Date', width: 75, dataIndex: 'lastPaidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Sales Rep', width: 95, dataIndex: 'salesRep'}),
        XCol.Create({ col: 9, text: 'Group', width: 60, dataIndex: 'groupId'}),
        XCol.Create({ col: 10, text: 'Terms', width: 60, dataIndex: 'terms', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'Avg Aging', width: 80, dataIndex: 'avgAging', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'Current Balance', width: 100, dataIndex: 'currentBal', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 13, text: 'Current Count', width: 70, dataIndex: 'curCnt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 14, text: 'Past Due Amount', width: 90, dataIndex: 'pastDue', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 15, text: 'Past Due Count', width: 90, dataIndex: 'pastDueCnt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 16, text: '15 Days', width: 80, dataIndex: 'days15', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 17, text: '30 Days', width: 80, dataIndex: 'days30', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 18, text: '45 Days', width: 80, dataIndex: 'days45', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 19, text: '60 Days ', width: 80, dataIndex: 'days60', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 20, text: '90 Days', width: 80, dataIndex: 'days90', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 21, text: 'Over', width: 80, dataIndex: 'over90', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 22, text: 'Total Balance ', width: 80, dataIndex: 'balance', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 23, text: 'Last Memo Title', width: 300, dataIndex: 'memo'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CustomerPaymentMemoListItem.prototype.customerName, orderByAscending: true };

    public static formatData(data: CustomerPaymentMemoListItem[]) {
        return data.map((d: CustomerPaymentMemoListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
        followUp: {from: 'fromFollowUp', to: 'toFollowUp'},
        lastPaidAmt: {from: 'fromLastPaidAmt', to: 'toLastPaidAmt'},
        lastPaidDate: {from: 'fromLastPaidDate', to: 'toLastPaidDate'},
        currentBal: {from: 'fromCurrentBal', to: 'toCurrentBal'},
        pastDue: {from: 'fromPastDue', to: 'toPastDue'},
        terms: {from: 'fromTerms', to: 'toTerms'},
        avgAging: {from: 'fromAvgAging', to: 'toAvgAging'},
        curCnt: {from: 'fromCurCnt', to: 'toCurCnt'},
        pastDueCnt: {from: 'fromPastDueCnt', to: 'toPastDueCnt'},
        days15: {from: 'fromDays15', to: 'toDays15'},
        days30: {from: 'fromDays30', to: 'toDays30'},
        days45: {from: 'fromDays45', to: 'toDays45'},
        days60: {from: 'fromDays60', to: 'toDays60'},
        days90: {from: 'fromDays90', to: 'toDays90'},
        over90: {from: 'fromOver90', to: 'toOver90'},
        balance: {from: 'fromBalance', to: 'toBalance'},
    }
}
